import { render, staticRenderFns } from "./SessionActive.vue?vue&type=template&id=65bbf49a&scoped=true"
import script from "./SessionActive.vue?vue&type=script&lang=js"
export * from "./SessionActive.vue?vue&type=script&lang=js"
import style0 from "./SessionActive.vue?vue&type=style&index=0&id=65bbf49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bbf49a",
  null
  
)

export default component.exports